import { sidebarConstants } from "../_constants";

export function sidebar(state = {}, action) {
  switch (action.type) {
  case sidebarConstants.SIDEBAR_ON:
    return {
      sidebarOnFlag: true,
      sidebarDevice: action.device
    };
  case sidebarConstants.SIDEBAR_OFF:
    return {
      sidebarOnFlag: false,
      sidebarDevice: null
    };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/sidebar.reducer.js